import { Injectable } from '@angular/core';
import { CommonService } from '../common/common.service';

@Injectable({
  providedIn: 'root',
})
export class ScheduleService {
  constructor(private common: CommonService) {}

  /**
   * 获取面试官面试日程
   * @param params
   */
  async getSchedule(params: object): Promise<any> {
    return new Promise((resolve) => {
      this.common.ajax({
        url: 'headhunting/getScheduleLists',
        data: params,
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }

  /**
   * 保存日程
   * @param params
   */
  async saveSchedule(params: object): Promise<any> {
    return new Promise((resolve) => {
      this.common.ajax({
        url: 'headhunting/editSchedule',
        data: params,
        type: 'post',
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }
  // 发布招聘-查询相同手机号
  getIdenticalMobileLists(params: any): Promise<unknown> {
    return this.common.ajax({
      url: 'headhunting/getIdenticalMobileLists',
      type: 'get',
      data: params,
      loading: true,
    });
  }
  /**
   * 获取面试官面试日程列表[根据指定招聘主体，指定日期，指定面试官，获取日程合集
   * @param params
   */
  async getScheduleList(params: object): Promise<any> {
    return new Promise((resolve) => {
      this.common.ajax({
        url: 'headhunting/getScheduleList',
        data: params,
        type: 'get',
        loading: true,
        success: (res) => {
          resolve(res);
        },
      });
    });
  }

  /**
   * 获取两个日期之间的所有日期
   * @param stime
   * @param etime
   */
  public getDiffDate(stime: any, etime: any): any {
    // 初始化日期列表，数组
    const diffdate = new Array();
    let stime_ts = new Date(stime).getTime();
    // 开始日期小于等于结束日期,并循环
    for (let i = 0; stime <= etime; i++) {
      diffdate.push(stime);
      // 获取开始日期时间戳
      stime_ts = new Date(stime).getTime();

      // 增加一天时间戳后的日期
      const next_date = stime_ts + 24 * 60 * 60 * 1000;

      // 拼接年月日，这里的月份会返回（0-11），所以要+1
      const next_dates_y = new Date(next_date).getFullYear() + '-';
      const next_dates_m =
        new Date(next_date).getMonth() + 1 < 10
          ? '0' + (new Date(next_date).getMonth() + 1) + '-'
          : new Date(next_date).getMonth() + 1 + '-';
      const next_dates_d = new Date(next_date).getDate() < 10 ? '0' + new Date(next_date).getDate() : new Date(next_date).getDate();
      stime = next_dates_y + next_dates_m + next_dates_d;
    }
    return diffdate;
  }
}
